import { selectFromDriverDto } from '../../models';

export default selectFromDriverDto()
  .id
  .uuid
  .name
  .speed
  .breakStartTime
  .breakEndTime
  .user(b => b.id.verified.email.fullname)
  .invite(i => i.id.inviteLink.email.inviteStatusId)
  .userInvite(i => i.id.uuid.email.inviteStatusId)
  .toString();
